import { render, staticRenderFns } from "./MemberAddress.vue?vue&type=template&id=64aee2cc&scoped=true&"
import script from "./MemberAddress.vue?vue&type=script&lang=js&"
export * from "./MemberAddress.vue?vue&type=script&lang=js&"
import style0 from "./MemberAddress.vue?vue&type=style&index=0&id=64aee2cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aee2cc",
  null
  
)

export default component.exports